import styled from 'styled-components';

export const StyledSearchInput = styled.div`
  .search-input {
    width: 100%;
  }

  .MuiOutlinedInput-root {
    height: ${(props) => props?.styleInput?.height || '40px'};
    padding-left: ${(props) => props?.styleInput?.paddingLeft || '0px'};
    border-radius: ${(props) => props?.styleInput?.borderRadius || '8px'};
  }
`;
